import { CitizenshipRegistrationAnscNotificationsMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import RegistrationCitizenshipAnscNotificationsShared from 'shell/components/shared/ansc-notifications/research-citizenship/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const RegistrationCitizenshipAnscNotificationsPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCitizenshipAnscNotificationsShared
        scope={IdAmbito.Mutazioni}
        items={CitizenshipRegistrationAnscNotificationsMutationCrumbs()}
      />
    </Fragment>
  );
};

RegistrationCitizenshipAnscNotificationsPage.displayName =
  'Registration Citizenship Notification Page component';

export default RegistrationCitizenshipAnscNotificationsPage;
